module.exports = __webpack_public_path__ + "static/img/competitiveness_01@3x.ea3198b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/competitiveness_01@3x.png
// module id = o+au
// module chunks = 1